import { render } from "./UiDropdownItem.vue?vue&type=template&id=51fc21dc"
import script from "./UiDropdownItem.vue?vue&type=script&lang=js"
export * from "./UiDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__